import type { InferRpcDefinition } from "@redotech/rpc/definition";
import { deleteMarketplaceListing } from "./schema/delete-marketplace-listing";
import { getInventoryValue } from "./schema/get-inventory-value";
import { getMarketplaceListings } from "./schema/get-marketplace-listings";
import { getMarketplacePayouts } from "./schema/get-marketplace-payouts";
import { getMarketplaceRevenue } from "./schema/get-marketplace-revenue";

export const rpcDefinition = {
  getMarketplacePayouts,
  getMarketplaceRevenue,
  getInventoryValue,
  getMarketplaceListings,
  deleteMarketplaceListing,
};

export type RedoLiquidationRpcDefinition = InferRpcDefinition<
  typeof rpcDefinition
>;
